import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Footer, IssuerStatement } from 'shared-components';
import { resolveCardholderFooterLinks } from 'shared-components/src/utils/footerLinks';
import { withTheme } from 'styled-components';

// Display order. `id` keys theme.brand.issuerStatements; message ids are the existing
// translation keys.
const ISSUER_STATEMENTS = [
  { id: 'ptc', messageId: 'issuer-statement-p1-text', description: 'Mastercard / Peoples Trust issuer statement' },
  { id: 'equitable', messageId: 'issuer-statement-p2-text', description: 'Visa / Equitable Bank issuer statement' },
  { id: 'sunrise', messageId: 'issuer-statement-p3-text', description: 'Visa / Sunrise Banks issuer statement' },
];

const FooterLayout = ({ theme, priv }) => {
  // Create intl instance
  const intl = useIntl();
  const balanceCheckerLinks = Object.values(theme.brand.cbc_footer || {})
    .filter(link => link.url.trim()) // Only include links with a valid URL
    .map(link => ({
      title: intl.locale === 'fr' ? link.title_fr : link.title_en,
      url: link.url,
    }));
  const isCheckCardBalance = window.location.href.includes('checkcardbalance');
  // Every portal page shows the configurable links; only the balance checker uses cbc_footer.
  const showCardholderLinks = !isCheckCardBalance;
  const cardholderLinks = showCardholderLinks
    ? resolveCardholderFooterLinks(theme.brand.cardholder_footer, intl.locale)
    : null;
  // Fixed copy; the white label can only hide a bank's statement.
  const enabled = theme.brand.issuerStatements || {};
  const LegalStatments = ISSUER_STATEMENTS.filter(({ id }) => enabled[id] !== false).map(
    ({ id, messageId, description }) => (
      <IssuerStatement key={id}>
        <FormattedMessage
          id={messageId}
          description={description}
          defaultMessage={intl.messages[messageId]}
        />
      </IssuerStatement>
    )
  );
  return (
    <Footer
      legalStatements={isCheckCardBalance ? [] : LegalStatments}
      companyName={
        isCheckCardBalance ? theme.brand.copyright_company_name : null
      }
      footerLinks={isCheckCardBalance ? balanceCheckerLinks : cardholderLinks}
      separateLinks={showCardholderLinks}
      priv={priv}
    />
  );
};

FooterLayout.propTypes = {
  theme: PropTypes.shape({
    brand: PropTypes.shape({
      cbc_footer: PropTypes.shape({}),
      cardholder_footer: PropTypes.arrayOf(PropTypes.shape({})),
      issuerStatements: PropTypes.shape({
        ptc: PropTypes.bool,
        equitable: PropTypes.bool,
        sunrise: PropTypes.bool,
      }),
      copyright_company_name: PropTypes.string,
    }),
  }),
  // Authenticated pages: dark text for the white background.
  priv: PropTypes.bool,
};

FooterLayout.defaultProps = {
  theme: { brand: {} },
  priv: false,
};

export default withTheme(FooterLayout);
